<template>
    <div class="section section-register-page registration-nko">
        <div class="container" v-if="!state.success.show">
            <div class="row between section-register-page__row">
                <div class="col d6 md-12">
                    <form
                        :action="params.form.action"
                        :method="params.form.method"
                        class="stepper-form"
                        @submit.prevent=""
                    >
                      <input :type="field.type" :name="field.name" :value="field.value" v-for="field in params.form.fields"/>
                      <a-stepper v-model="state.step" ref="stepper">
                            <a-step :name="i" v-for="(item, i) in state.steps" :key="i">
                              <h3>{{item.title}}</h3>
                              <div class="form-group row">
                                <div class="col sm-12" :class="'d'+field.greedLang" v-for="field in item.fields">
                                  <AInput
                                      v-if="field.name === 'NPO[PROP][ASSETS]' && item.fields.find(f => f.name === 'ASSETS_CHECKBOX')?.value === true"
                                      :type="field.type"
                                      :label="field.title"
                                      :placeholder="field.leftIcon?'':field.title"
                                      :name="field.name"
                                      :staticLabel="field.title!=''"
                                      v-model="field.value"
                                      @click="field.error=false"
                                      :error="field.error"
                                      :class="field.leftIcon&&field.title?'fields-group':''"
                                  />
                                  <a-input
                                      v-if="['password', 'text', 'bool'].includes(field.type) && field.name !== 'NPO[PROP][ASSETS]'"
                                      :type="field.type"
                                      :label="field.title"
                                      :placeholder="field.leftIcon?'':field.title"
                                      :name="field.name"
                                      :staticLabel="field.title!=''"
                                      v-model="field.value"
                                      @click="field.error=false"
                                      :error="field.error"
                                      :class="field.leftIcon&&field.title?'fields-group':''"
                                  >
                                    <template #before v-if="field.leftIcon">
                                      <div class="icon dark">
                                        <img :src="field.leftIcon" width="25" height="25" style="filter: invert(1);object-fit: contain;">

                                      </div>
                                    </template>
                                  </a-input>

                                    <div class="textareaEditorWrap" v-if="field.type=='textarea'">
                                        <label class="label">{{field.title}}</label>
                                        <ckeditor :editor="editor" v-model="field.value" :config="editorConfig"></ckeditor>
                                    </div>

                                  <a-date-picker
                                      v-if="field.type=='date'"
                                      :label="field.title"
                                      :placeholder="field.title"
                                      :name="field.name"
                                      :useManualInput="true"
                                      @click="field.error=false"
                                      :error="field.error"
                                      staticLabel
                                      v-model="field.value"
                                  />
                                  <a-checkbox
                                      v-if="field.type=='checkbox'"
                                      :name="field.name"
                                      :disabled="field.disabled"
                                      :label="field.title"
                                      :checked="field.disabled||field.value?true:false"
                                      v-model="field.value"
                                  />
                                  <a-input
                                      v-if="field.type=='file'"
                                      class="field-dnd"
                                      :label="field.title"
                                      @click="field.error=false"
                                      :placeholder="field.placeholder"
                                      :hint="field.hint"
                                      :name="field.name"
                                      staticLabel
                                      :type="field.type"
                                      v-model="field.value"
                                      :error="field.error"
                                    >
                                    <template #append v-if="field.type=='file'&&field.value">
                                        <span class="a-field-file-clear" @click="field.value=''"></span>
                                    </template>
                                    </a-input>
                                  <a-select
                                      v-if="field.type=='select'"
                                      class="a-select-tags"
                                      :label="field.title"
                                      :placeholder="field.multiple?`${field.title}: ${field.value.length} из ${field.options.length}`:(field.value?(field.options.find(element => element.id == field.value).name):(field.placeholder?field.placeholder:field.title))"
                                      :name="field.name"
                                      staticLabel
                                      :options="field.options"
                                      display="name"
                                      value="id"
                                      :multiple="field.multiple"
                                      :error="field.error"
                                      v-model="field.value"
                                  >
                                    <template #item="item">
                                      <div class="flex v-center">
                                        <a-checkbox :label="item.name" v-model="item.selected"/>
                                      </div>
                                    </template>
                                  </a-select>

                                  <div class="tags flex wrap" v-if="field.type=='select'&&field.multiple&&field.value.length > 0">
                                    <a-chip removable v-for="(tag, i) in field.value" :key="i" @remove="removeCategory(i,field)">{{ tag.name }}</a-chip>
                                  </div>
                                  <div class="fields-desc" v-if="field.type=='label'">{{field.value}}</div>
                                  <ABtn class="form-btn btn-add" fill="transparent" type="button" @click="addEmployees(field)" v-if="field.type=='subElements'">
                                    <template #before>
                                      <svg class="icon" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <rect y="9" width="20" height="2"/>
                                        <rect x="9" y="20" width="20" height="2" transform="rotate(-90 9 20)"/>
                                      </svg>
                                    </template>
                                    <template #content>{{field.messages.btnAdd}}</template>
                                  </ABtn>
                                  <div class="employee-item" v-for="(employee, i) in field.employees" :key="i" v-if="field.type=='subElements'">
                                    <div class="flex v-center between">
                                      <h3>{{ field.messages.sotrudnikText }}{{i + 1}}</h3>
                                      <ABtn fill="flat" :label="field.messages.btnDel" @click="removeEmployee(field,i)" color="#000" type="button" />
                                    </div>
                                    <div class="form-group row">
                                      <div class="col sm-12" :class="'d'+EmployField.greedLang" v-for="(EmployField,k) in field.fields">
                                        <a-input
                                            v-if="EmployField.type=='text'||EmployField.type=='textarea'"
                                            :type="EmployField.type"
                                            :label="EmployField.title"
                                            :placeholder="EmployField.title"
                                            :name="EmployField.name"
                                            :error="field.employees[i][k].error"
                                            staticLabel
                                            v-model="field.employees[i][k].value"
                                        />
                                        <a-select
                                            v-if="EmployField.type=='select'"
                                            :label="EmployField.title"
                                            :placeholder="EmployField.title"
                                            :name="EmployField.name"
                                            staticLabel
                                            :options="EmployField.options"
                                            value="id"
                                            display="name"
                                            v-model="field.employees[i][k].value"
                                            :error="field.employees[i][k].error"
                                            :validator="(val) => item.processed ? required(val) : true"
                                        />
                                        <a-input
                                            v-if="EmployField.type=='file'"
                                            class="field-dnd"
                                            :label="EmployField.title"
                                            :placeholder="EmployField.placeholder"
                                            :hint="EmployField.hint"
                                            :name="EmployField.name"
                                            staticLabel
                                            :type="EmployField.type"
                                            v-model="field.employees[i][k].value"
                                            :error="field.employees[i][k].error"
                                        >
                                            <template #append v-if="field.type=='file'&&field.employees[i][k].value">
                                                <span class="a-field-file-clear" @click="field.employees[i][k].value=''"></span>
                                            </template>
                                        </a-input>
                                        <div class="fields-desc" v-if="EmployField.type=='label'">{{EmployField.value}}</div>
                                      </div>
                                    </div>
                                    <ABtn class="form-btn btn-add" fill="transparent" type="button" @click="addEmployees(field)" v-if="i + 1 < field.maxcount">
                                      <template #before>
                                        <svg class="icon" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                          <rect y="9" width="20" height="2"/>
                                          <rect x="9" y="20" width="20" height="2" transform="rotate(-90 9 20)"/>
                                        </svg>
                                      </template>
                                      <template #content>{{field.messages.btnAdd}}</template>
                                    </ABtn>
                                  </div>
                                  <div class="form-group " v-if="field.type=='moreSotsLink'">
                                    <ABtn class="form-btn btn-add" fill="transparent" type="button" @click="addSocialLink(field)">
                                      <template #before>
                                        <svg class="icon" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                          <rect y="9" width="20" height="2"/>
                                          <rect x="9" y="20" width="20" height="2" transform="rotate(-90 9 20)"/>
                                        </svg>
                                      </template>
                                      <template #content>{{field.messages.btnAdd}}</template>
                                    </ABtn>

                                    <div class="row nowrap" v-for="(social, i) in field.links" :key="i">
                                      <div class="col d5 sm-6" :class="'d'+linkField.greedLang" v-for="(linkField,k) in social">
                                        <a-input
                                            v-if="linkField.type=='text'||linkField.type=='textarea'"
                                            :label="linkField.title"
                                            staticLabel
                                            v-model="linkField.value"
                                            :error="linkField.error"
                                        >
                                          <template #before v-if="k==0">
                                            <ABtn type="button" class="social-link__remove" fill="flat" style="color: #68737D;" @click="removeSocialLink(i,field.links)">
                                              <template #content>
                                                <svg width="20" height="20" viewBox="0 0 20 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <rect width="20" height="2" fill="#68737D"/>
                                                </svg>
                                              </template>
                                            </ABtn>
                                          </template>
                                        </a-input>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col sm-12 d12" v-if="item.afterFieldsBlock">
                                  <div class="stepper-companies">
                                    <div class="stepper-companies__header flex between v-center">
                                      <div class="stepper-companies__title">{{item.afterFieldsBlock.title}}</div>
                                      <div class="slider-cards__btns">
                                        <button class="swiper-button-prev" ref="btnPrev" aria-label="previous slide">
                                          <svg class="icon" width="26" height="20" viewBox="0 0 26 20" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.28201 18.4849L1.50383 10.7068C1.11331 10.3162 1.11331 9.68308 1.50383 9.29256C1.89436 8.90203 2.52752 8.90203 2.91804 9.29256L10.6962 17.0707C11.0867 17.4613 11.0867 18.0944 10.6962 18.4849C10.3057 18.8755 9.67253 18.8755 9.28201 18.4849Z"/>
                                            <path d="M1.50383 10.7065C1.11331 10.3159 1.11331 9.68278 1.50383 9.29225C1.89435 8.90173 2.52752 8.90173 2.91804 9.29225C3.30857 9.68278 3.30857 10.3159 2.91804 10.7065C2.52752 11.097 1.89436 11.097 1.50383 10.7065Z"/>
                                            <path d="M3.21094 8.80811L24.2109 8.80811C24.7632 8.80811 25.2109 9.25582 25.2109 9.80811C25.2109 10.3604 24.7632 10.8081 24.2109 10.8081L3.21094 10.8081C2.65865 10.8081 2.21094 10.3604 2.21094 9.80811C2.21094 9.25582 2.65865 8.80811 3.21094 8.80811Z"/>
                                            <path d="M1.50676 9.29324L9.28493 1.51506C9.67545 1.12454 10.3086 1.12454 10.6991 1.51506C11.0897 1.90559 11.0897 2.53875 10.6991 2.92927L2.92097 10.7074C2.53044 11.098 1.89728 11.098 1.50676 10.7074C1.11623 10.3169 1.11623 9.68376 1.50676 9.29324Z"/>
                                          </svg>
                                        </button>
                                        <button class="swiper-button-next" ref="btnNext" aria-label="next slide">
                                          <svg class="icon" width="26" height="20" viewBox="0 0 26 20" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.28201 18.4849L1.50383 10.7068C1.11331 10.3162 1.11331 9.68308 1.50383 9.29256C1.89436 8.90203 2.52752 8.90203 2.91804 9.29256L10.6962 17.0707C11.0867 17.4613 11.0867 18.0944 10.6962 18.4849C10.3057 18.8755 9.67253 18.8755 9.28201 18.4849Z"/>
                                            <path d="M1.50383 10.7065C1.11331 10.3159 1.11331 9.68278 1.50383 9.29225C1.89435 8.90173 2.52752 8.90173 2.91804 9.29225C3.30857 9.68278 3.30857 10.3159 2.91804 10.7065C2.52752 11.097 1.89436 11.097 1.50383 10.7065Z"/>
                                            <path d="M3.21094 8.80811L24.2109 8.80811C24.7632 8.80811 25.2109 9.25582 25.2109 9.80811C25.2109 10.3604 24.7632 10.8081 24.2109 10.8081L3.21094 10.8081C2.65865 10.8081 2.21094 10.3604 2.21094 9.80811C2.21094 9.25582 2.65865 8.80811 3.21094 8.80811Z"/>
                                            <path d="M1.50676 9.29324L9.28493 1.51506C9.67545 1.12454 10.3086 1.12454 10.6991 1.51506C11.0897 1.90559 11.0897 2.53875 10.6991 2.92927L2.92097 10.7074C2.53044 11.098 1.89728 11.098 1.50676 10.7074C1.11623 10.3169 1.11623 9.68376 1.50676 9.29324Z"/>
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                                    <div class="slider-cards__wrap">
                                      <swiper
                                          :navigation="{prevEl: btnPrev, nextEl: btnNext}"
                                          :modules="modules"
                                          v-bind="{
                                          slidesPerView: 5,
                                          breakpoints: {
                                              320: {
                                                  slidesPerView: 2.2,
                                                  spaceBetween: 20,
                                              },
                                              600: {
                                                  slidesPerView: 3.2,
                                                  spaceBetween: 20,
                                              },
                                              768: {
                                                  slidesPerView: 5,
                                                  spaceBetween: 8,
                                              },
                                          },
                                      }">

                                        <!--
                                                                              <swiper-slide>
                                          <a-input
                                              class="field-dnd input-slide"
                                              label=""
                                              placeholder="Выберите файл"
                                              name="company_logo"
                                              staticLabel
                                              type="file"
                                              @change="changeLogoInput($event)"
                                              v-model="state.steps[3].fields.company_logo.value"
                                          >
                                              <template #prepend>
                                                  <img :src="state.steps[3].fields.company_logo.preview" />
                                              </template>
                                          </a-input>
                                      </swiper-slide>
                                        -->
                                        <swiper-slide v-for="(slide, i) in item.afterFieldsBlock.items" :key="i">
                                          <div class="slide-company">
                                            <div class="slide-company__inner">
                                              <div class="slide-company__media">
                                                <img :src="slide.img" :alt="slide.title">
                                              </div>
                                            </div>
                                          </div>
                                        </swiper-slide>


                                      </swiper>
                                    </div>
                                  </div><br>
                                </div>
                              </div><br>
                              <div class="row">
                                <div class="col d6 sm-12" :class="'d'+(12/Object.keys(item.buttons).length)" v-for="button in item.buttons">
                                  <ABtn
                                      class="dark d12"
                                      :label="button.title"
                                      type="button"
                                      :fill="button.fill"
                                      :disabled="button.disabled"
                                      @click="clickStepButton(button)"
                                  />
                                </div>
                              </div>
                            </a-step>
                        </a-stepper>
                    </form>
                </div>
                <div class="col d6 md-12">
                    <div class="stepper-nav">
                        <div class="stepper-nav__inner">
                            <div class="stepper-nav__list">
                                <div
                                    :class="['stepper-nav__item', state.step === i ? 'stepper-nav__item--active' : '']" 
                                    v-for="(item, i) in state.steps" :key="i" 
                                    @click="stepGoTo(i)"
                                >
                                    <div class="stepper-nav__item-title">{{params.messages.step}} {{Object.keys(state.steps).indexOf(i)+1}}<span> из {{ Object.keys(state.steps).length }}</span></div>
                                    <div class="stepper-nav__item-desc">{{ item.menuItem}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="register-success" v-if="state.success.show">
            <div class="register-success__body">
                <div class="register-success__icon">
                    <img src="/local/templates/main/img/icons/ok-hand.png" alt="">
                </div>
                <div class="register-success__title h2">{{ state.success.title }}</div>
                <div class="register-success__desc" v-html="state.success.desc"></div>
                <ABtn label="Хорошо" :href="state.success.url" class="primary" />
            </div>
        </div>
    </div>
</template>

<script>
import { AStepper, AStep, AField, AInput, ACheckbox, ABtn, ASelect, AChip, ADatePicker, useAProgressBar } from '../ui'
import SliderCards from '../SliderCards.vue'
import { send } from '../../services/api'
import { getType } from '../ui/utils/helpers'
import { ref, computed } from 'vue'
import { required, isEmail, isPhone, fileRules } from '../../libs/Validators'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from "swiper";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default {
    name: 'RegisterNPO',
    components: {
        AStepper,
        AStep,
        AChip,
        AField,
        AInput,
        ACheckbox,
        ABtn,
        ASelect,
        SliderCards,
        Swiper,
        SwiperSlide,
        Navigation,
        ADatePicker,
    },
    props: ['params'],
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [
                    'heading',
                    '|',
                    'bold',
                    'italic',
                    'link',
                    'bulletedList',
                    'numberedList',
                    'blockQuote',
                    'insertTable'
                ],
                heading: {
                    options: [
                        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' }
                    ]
                }
            }
        };
    },
    setup: (props, ctx) => {
        const btnNext = ref(null)
        const btnPrev = ref(null)
        const stepper = ref(null)
        const progress = useAProgressBar()
        const getCurrentDate = () => {
            const date = new Date()
            const dd = String(date.getDate()).padStart(2, '0')
            const mm = String(date.getMonth() + 1).padStart(2, '0')
            const yyyy = date.getFullYear()
            return dd + '.' + mm + '.' + yyyy
        }
        const state = ref({
            success: props.params.success,
            step: Object.keys(props.params.form.steps)[0],
            steps: props.params.form.steps,
        })
        const addEmployees = (field) => {
            if(field.employees.length < field.maxcount) {
                field.employees.push(JSON.parse(JSON.stringify(field.fields)));
            }
        }
        const removeEmployee = (field,i) => {
          field.employees.splice(i, 1);
        }
        const addSocialLink = (field) => {
          const copyObject = JSON.parse(JSON.stringify(field.fields));
          field.links.push(copyObject);
        }
        const removeSocialLink = (i,field) => {
          field.splice(i, 1);
        }
        const removeCategory = (i,field) => {
          field.value.splice(i, 1)
        }
        const clickStepButton = (button) => {
          if(button.action==="setStep"&&!button.disabled) {
            if(stepValidate(state.value.step, true)) return;
            stepGoTo(button.value);
          } else if(button.action==="submit") {
            if(stepValidate(state.value.step, true)) return;
            formSend();
          }
        }
        const stepGoTo = (i) => {
          let oldStepPosition = 0;
          let newStepPosition = 0;
          let index = 0;
          for (let k in state.value.steps) {
            if(k===state.value.step) {
              oldStepPosition = index;
            }
            if(k===i) {
              newStepPosition = index;
            }
            index++;
          }
          if(newStepPosition > oldStepPosition) {
              if(stepValidate(state.value.step, true)) return;
          }
          if(state.value.steps[i].disabled) return;
          stepper.value.goTo(i);
        }
        const CheckOneField = (field,step) => {
          if(field.req) {
            if(field.reqtype==="file") {
              if (!field.value) {
                return false;
              }
            } else if (field.value+''.trim()===""||!field.value) {
              return false;
            }
          }
          if(field.rules) {
            for(let ruleIndex in field.rules) {
              switch (field.rules[ruleIndex].rule) {
                case "minLength":
                  if(field.value.length<field.rules[ruleIndex].val) {
                    showNotification("danger",field.title, field.rules[ruleIndex].invalidMessage);
                    return false;
                  }
                break;
                case "compare":
                  let norm = false;
                  const fields = state.value.steps[step].fields;
                  for(let f in fields) {
                    if(fields[f].name===field.rules[ruleIndex].val) {
                      if(field.value===fields[f].value) {
                        norm = true;
                      }
                    }
                  }
                  if(!norm) {
                    showNotification("danger",field.title, field.rules[ruleIndex].invalidMessage);
                    return false;
                  }
                break;
              }
            }
          }
          else if(field.reqtype) {
            switch (field.reqtype) {
              case "email":
                if(!isEmail(field.value)) {
                  return false;
                }
                break;
              case "phone":
                if(!isPhone(field.value)) {
                  return false;
                }
                break;
              case "password":
                if(field.compare) {
                  let norm = false;
                  const fields = state.value.steps[step].fields;
                  for(let f in fields) {
                    if(fields[f].name===field.compare) {
                      if(field.value===fields[f].value) {
                        norm = true;
                      }
                    }
                  }
                  if(!norm) {
                    return false;
                  }
                }
              break;
              case "file":
                if(field.formats||field.maxSize) {
                  if(!fileRules(field.value, { maxSize: field.maxSize, allowedExt: field.formats})) {
                    return false;
                  }
                }
              break;
            }
          }
          return true;
        }
        const stepValidate = (i, showErrors = false) => {
            const fields = state.value.steps[i].fields;
            let error = false;
            for(let fieldIndex in fields) {
              fields[fieldIndex].error = false;
            }

            for(let fieldIndex in fields) {
              if(!CheckOneField(fields[fieldIndex],i)) {
                fields[fieldIndex].error = true;
                error = true
              }

              //Проверяем Сотрудников
              if(fields[fieldIndex].type==="subElements"&&fields[fieldIndex].employees.length>0) {
                for(let subElementIndex in fields[fieldIndex].employees) {
                  for(let subElementFieldIndex in fields[fieldIndex].employees[subElementIndex]) {
                    if(typeof fields[fieldIndex].employees[subElementIndex][subElementFieldIndex]=== 'object') {
                      fields[fieldIndex].employees[subElementIndex][subElementFieldIndex].error = false;
                    }
                  }
                  for(let subElementFieldIndex in fields[fieldIndex].employees[subElementIndex]) {
                    if(!CheckOneField(fields[fieldIndex].employees[subElementIndex][subElementFieldIndex],i)) {
                      if(typeof fields[fieldIndex].employees[subElementIndex][subElementFieldIndex]=== 'object') {
                        fields[fieldIndex].employees[subElementIndex][subElementFieldIndex].error = true;
                        error = true
                      }
                    }
                  }
                }
              }

              //Проверяем соцсети

              if(fields[fieldIndex].type==="moreSotsLink"&&fields[fieldIndex].links.length>0) {
                for(let subElementIndex in fields[fieldIndex].links) {
                  for(let subElementFieldIndex in fields[fieldIndex].links[subElementIndex]) {
                    if(typeof fields[fieldIndex].links[subElementIndex][subElementFieldIndex]=== 'object') {
                      fields[fieldIndex].links[subElementIndex][subElementFieldIndex].error = false;
                    }
                  }
                  for(let subElementFieldIndex in fields[fieldIndex].links[subElementIndex]) {
                    if(typeof fields[fieldIndex].links[subElementIndex][subElementFieldIndex]=== 'object') {
                      if (!CheckOneField(fields[fieldIndex].links[subElementIndex][subElementFieldIndex], i)) {
                        fields[fieldIndex].links[subElementIndex][subElementFieldIndex].error = true;
                        error = true
                      }
                    }
                  }
                }
              }
            }
            return error
        }
        const formdataAppendItem = (formDataObj,field)=> {
          let val = field.value;
          if(getType(field.value) === 'FileList') {
            val = field.value[0];
          }
          else if(typeof field.value=="object") {
            val = [];
            for(let obI in field.value) {
              if(field.value[obI].id&&field.value[obI].id!==undefined) {
                val.push(field.value[obI].id);
              }
            }
          }
          if(val&&field.name) {
            formDataObj.append(field.name, val);
          }
        }
        const formSend = async () => {
          progress.show();
          let data = {};
          const formData = new FormData();
          for (let stepCode in state.value.steps) {
            let fields = state.value.steps[stepCode].fields;
            for(let fieldIndex in fields) {
              if(typeof fields[fieldIndex] === 'object') {
                if(fields[fieldIndex].links!==undefined) {
                  for(let subElementIndex in fields[fieldIndex].links) {
                    for(let subElementFieldIndex in fields[fieldIndex].links[subElementIndex]) {
                      if(typeof fields[fieldIndex].links[subElementIndex][subElementFieldIndex]=== 'object') {
                        formdataAppendItem(formData,fields[fieldIndex].links[subElementIndex][subElementFieldIndex]);
                      }
                    }
                  }
                } else if(fields[fieldIndex].employees!==undefined) {
                  for(let subElementIndex in fields[fieldIndex].employees) {
                    for(let subElementFieldIndex in fields[fieldIndex].employees[subElementIndex]) {
                      if(typeof fields[fieldIndex].employees[subElementIndex][subElementFieldIndex]=== 'object') {
                        formdataAppendItem(formData,fields[fieldIndex].employees[subElementIndex][subElementFieldIndex]);
                      }
                    }
                  }
                } else {
                  formdataAppendItem(formData,fields[fieldIndex]);
                }
              }
            }
          }
          for (let stepCode in props.params.form.fields) {
            formdataAppendItem(formData,props.params.form.fields[stepCode]);
          }

          await send(props.params.form.action, {method:props.params.form.method},formData).then((response) => {
            if(response["RegisterNPO"]['information']) {
              let notyByType = {};
              for (let index in response["RegisterNPO"]['information'])  {
                if(response["RegisterNPO"]['information'][index].type!==undefined) {
                  if(notyByType[response["RegisterNPO"]['information'][index].type]===undefined) {
                    notyByType[response["RegisterNPO"]['information'][index].type] = [];
                  }
                  notyByType[response["RegisterNPO"]['information'][index].type].push(response["RegisterNPO"]['information'][index].text);
                }
              }
              for (let type in notyByType) {
                showNotification(type,'',notyByType[type].join('<br>'));
              }
            }
            if(response["RegisterNPO"]['success']['show']) {
              state.value.success = response["RegisterNPO"]['success'];
            }
            progress.hide();
          })
        }
        const isNext = computed(() => {
            return !state.value.steps[0].fields.nko_name.validator(state.value.steps[0].fields.nko_name.value)
        })

        return {
            isNext,
            stepper,
            clickStepButton,
            stepGoTo,
            state,
            showNotification,
            addSocialLink,
            removeSocialLink,
            btnNext,
            btnPrev,
            addEmployees,
            removeEmployee,
            removeCategory,
            modules: [Navigation],
            required,
            isEmail,
            isPhone,
            fileRules,
            formSend,
        }
    },
}
</script>

<style lang="scss">
.registration-nko .a-checkbox {
  margin-top: 20px;
}
    .registration-nko {
        .section-register-page__row {
            @include tablet {
                flex-direction: column-reverse;
                align-items: stretch;
            }
        }
    }
    .section-register-page {
        @include tablet {
            padding: 24px 0;
        }
    }
    .tags {
        margin: 10px -5px 0 -5px;
        .a-chip {
            padding: 0 5px;
        }
    }
    .employee-item {
        margin-top: 40px;
    }
    .fields-desc {
        margin-top: 10px;
        font-size: 12px;
        line-height: 16px;
        color: var(--c-gray-400);
        max-width: 650px;
    }
    .form-btn {
        margin-top: 26px;
    }
    .btn-add {
        padding: 0;
        color: var(--c-gray-400);
        .icon {
            fill: currentColor;
        }
    }
    .stepper-form {
        @include tablet {
            margin-top: 48px;
        }
        @include mobile {
            margin-top: 30px;
        }
        h3 {
            margin: 0;
        }
        .a-stepper {
            &__footer {
                margin-top: 36px;

                @include mobile {
                    .col:last-child {
                        margin-top: 20px;
                    }
                }
            }
        }
    }
    .stepper-nav {
        width: 100%;
        max-width: 446px;
        margin: 75px auto 0 auto;
        position: sticky;
        top: 110px;
        
        @include tablet {
            margin: 0;
            max-width: initial;
            position: relative;
            top: 0;
        }
        &__inner {
            background: #fff;
            overflow: hidden;
            border-radius: var(--br-1);
            box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);

            @include tablet {
                box-shadow: none;
                border: 1px solid var(--c-gray-700)
            }
        }
        &__item {
            cursor: pointer;
            padding: 16px 21px;
            transition: all .3s ease;
            color: var(--c-gray-100);
            border-bottom: 1px solid var(--c-gray-800);

            @include tablet {
                display: none;
            }

            &:last-child {
                border-bottom: none;
            }
            &:hover {
                background: var(--c-gray-700);
            }
            &.disabled {
                opacity: 0.5;
                pointer-events: none;
            }
            &--active {
                background: var(--c-secondary-200);
                border-color: var(--c-secondary-200);
                color: #fff;
                &:hover {
                    background: var(--c-secondary-200);
                    border-color: var(--c-secondary-200);
                    color: #fff;
                }
                @include tablet {
                    display: block;
                    background: #fff;
                    border: none;
                    color: #000;
                }
            }
            &-title {
                font-family: var(--font-secondary);
                font-weight: 600;
                font-size: 18px;
                line-height: 28px;

                span {
                    display: none;
                    @include tablet {
                        display: inline;
                    }
                }
            }
            &-desc {
                font-size: 16px;
                line-height: 26px;
            }
        }
    }
    .stepper-companies {
        margin-top: 35px;
        &__header {
            margin-bottom: 15px;
        }
        &__title {
            font-size: 14px;
            line-height: 20px;
        }
        .swiper {
            @include mobile {
                margin: 0 -15px;
                padding: 0 15px;
            }
        }
        .slider-cards__btns {
            display: flex;

            @include tablet {
                position: relative;
                top: auto;
            }
            .swiper {
                &-button {
                    &-prev,
                    &-next {
                        position: relative;
                        left: auto;
                        right: auto;
                        top: auto;
                        margin: 0;
                        width: 30px;
                        height: 30px;

                        svg {
                            width: 12px;
                            height: 9px;
                        }
                    }
                    &-next {
                        margin-left: 10px;
                    }
                }
            }
        }
    }
    .input-slide {
        margin: 0 !important;
        .field-content {
            position: relative;
            padding-bottom: 100%;
            width: 100%;
            display: block;
            text-align: center;
            flex: initial;
            background: transparent;
            line-height: 20px;
        }
        .field-prepend {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0;
            padding: 16px;
            img {
                object-fit: contain;
            }
        }
        .a-field-file-input-value {
            display: none !important;
        }
        .control-wrap {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
        .a-field-file-input-placeholder {
            @include tablet {
                width: 100%;
                text-align: center;
                margin: auto;
                max-width: 70px;
            }
        }
    }
    .slide-company {
        &__inner {
            cursor: pointer;
            background: #fff;
            border-radius: var(--br-1);
            overflow: hidden;
            border: 1px solid var(--c-gray-700);
            transition: all .3s ease;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            padding-bottom: calc(100% - 2px);
        }
        &__media {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            @include mobile {
                padding: 16px;
            }
            img {
                object-fit: contain;
            }
        }
    }

    .social-link__remove {
        width: 50px;
        @include mobile {
            width: 30px;
            padding: 0;
        }
    }

    .register-success {
        @include mobile {
            position: fixed;
            display: flex;
            align-items: flex-end;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: #2F3941;
            z-index: 999;
        }
        &__body {
            text-align: center;
            background: #FFFFFF;
            box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
            border-radius: 6px;
            padding: 77px 90px;
            width: 90%;
            max-width: 922px;
            margin: auto;

            @include tablet {
                padding: 56px 30px;
            }

            @include mobile {
                max-width: initial;
                width: 100%;
                border-radius: 22px 22px 0px 0px;
                padding: 44px 15px 30px 15px;
                margin: 0;
            }
        }
        &__icon {
            text-align: center;
            margin-bottom: 22px;

            @include mobile {
                margin-bottom: 8px;
            }
        }
        &__title {
            @include mobile {
                max-width: 200px;
                margin: auto;
            }
        }
        &__desc {
            font-size: 16px;
            line-height: 26px;
            max-width: 725px;
            margin: 28px auto 0 auto;
        }
        .a-btn {
            min-width: 200px;
            margin-top: 40px;
            @include mobile {
                width: 100%;
                margin-top: 24px;
            }
        }
    }
</style>